var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.multiple
        ? _c(
            "yxt-select",
            {
              ref: "dropTree",
              staticClass: "talentrv-select-tree__wrapper",
              staticStyle: { width: "180px" },
              attrs: {
                placeholder: _vm.$t("pc_gwnl_global_lbl_dept").d("部门"),
                "popper-class": "tree-wrap",
                multiple: "",
                "collapse-tags": "",
                clearable: "",
                disabled: _vm.disabled,
                size: "small",
              },
              on: { clear: _vm.clear },
              model: {
                value: _vm.department.id,
                callback: function ($$v) {
                  _vm.$set(_vm.department, "id", $$v)
                },
                expression: "department.id",
              },
            },
            [
              _c(
                "yxt-option",
                {
                  staticClass: "talentrv-drop__tree",
                  attrs: {
                    value: _vm.department.id,
                    label: _vm.department.name,
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "400px" } },
                    [
                      _c("yxtbiz-dept-tree", {
                        ref: "deptTree",
                        staticClass: "yxtbiz-dept-virtual-tree",
                        attrs: {
                          "default-expanded-keys": [],
                          functions: _vm.functions,
                          filterable: _vm.filterable,
                          functionCode: _vm.functionCode,
                          dataPermissionCode: _vm.dataPermissionCode,
                          enableGroupCorp: _vm.enableGroupCorp,
                          visibleOrgSelector: _vm.visibleOrgSelector,
                        },
                        on: { nodeClick: _vm.nodeClick },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "template",
                { slot: "tag" },
                [
                  _c("yxtbiz-dept-name", {
                    attrs: { name: _vm.department.name },
                  }),
                ],
                1
              ),
            ],
            2
          )
        : _c("yxt-select", {
            staticStyle: { width: "180px" },
            attrs: {
              multiple: "",
              placeholder: _vm.$t("pc_gwnl_global_lbl_dept").d("部门"),
              size: "small",
              "icon-name": "more",
              "hidden-option": "",
              "collapse-tags": "",
              "value-key": "id",
              "prop-label": "name",
              disabled: _vm.disabled,
            },
            on: {
              "visible-change": _vm.onMultiSelectorClick,
              "remove-tag": _vm.onMultiRemoveDept,
            },
            scopedSlots: _vm._u([
              {
                key: "tag",
                fn: function (ref) {
                  var data = ref.data
                  return [
                    _c("yxtbiz-dept-name", {
                      attrs: { name: data.currentLabel },
                    }),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.multiDepartment,
              callback: function ($$v) {
                _vm.multiDepartment = $$v
              },
              expression: "multiDepartment",
            },
          }),
      _c("yxtbiz-eval-select-department", {
        attrs: {
          visible: _vm.showMultiDrawer,
          "default-value": _vm.multiDepartment,
          "check-strictly": true,
          "children-included": _vm.childrenIncluded,
          "function-code": _vm.functionCode,
          dataPermissionCode: _vm.dataPermissionCode,
        },
        on: {
          "update:visible": function ($event) {
            _vm.showMultiDrawer = $event
          },
          "on-selection": _vm.onMultiDeptSelected,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }